module.exports = __webpack_public_path__ + "static/media/felix.2dc1ffb0.jpeg";